export interface MediaFolder {
	folderName: string;
	displayName: string;
	color: string;
}

export const folders: MediaFolder[] = [
	{
		folderName: 'shout',
		displayName: 'Ape FilCoSpe',
		color: '#ff7000',
	},
];
